import React from 'react';

export default function DropdownValueSmall(props: any) {


    const option = props.option ? props.option : {};

    if (!option) return null;

    const optionColor = _.get(option, 'color', null); //!_.isNil(option.color) ? option.color : null;

    const classes = Classes("ui5-txt-less-important-small", "fl-ac", "m-t-4", "m-b-4", props.className)

    if (optionColor) {

        const pillClasses = Classes(
            "ui5-pillbox s22",
            "gd-c-bgp-"+optionColor,
            "gd-c-pale-border-"+optionColor,
            props.className
        )

        // Limit Pill width by style={{maxWidth: `calc(100% - 37px)`}}
        return (
            <div className={pillClasses} style={{maxWidth: `calc(100% - 37px)`}}>
                {option.label}
            </div>
        )
    }

    return (
        <div className={classes} style={{maxWidth: `calc(100% - 37px)`}}>
            {_.get(props.field.components, 'ValueIcon', false)}
            <span className="txt-truncate">{option.label}</span>
        </div>
    )


}
